import React from 'react';
import { alpha, Box, Divider } from '@mui/material';
import useBundleTranslation from 'i18n';
import { IKpiTooltipProps } from './index';
import { IKpiMeasurePointData } from 'components/report-content/components/kpi-chart/series/getMeasurementSeries';
import moment from 'moment/moment';
import CloseIcon from './CloseIcon';

export default function KpiMeasureSeriesTooltip({ isSelected, point, onClose }: IKpiTooltipProps) {
    const { t } = useBundleTranslation(['components/report-content']);
    const customData = point.options.custom as IKpiMeasurePointData;
    const headerBlock = (
        <>
            <Box
                dangerouslySetInnerHTML={{ __html: point?.series?.name ?? '' }}
                sx={{ fontWeight: 600, pr: isSelected ? 1.5 : undefined }}
            />
            {isSelected && <CloseIcon onClose={onClose} />}
            <Box sx={{ mt: 0.5 }}>
                {t('kpi_chart.label_value_on_time', {
                    value: customData.y_f,
                    time: moment(customData.x_f).format('YYYY-MM-DD'),
                })}
            </Box>
        </>
    );

    if (typeof point.y == 'undefined' || point.y == null) {
        return (
            <Box sx={{ py: 1, px: 1.5 }}>
                {headerBlock}
                <Divider sx={{ my: 1 }} />
                <Box sx={{ color: (theme) => alpha(theme.palette.text.primary, 0.64) }}>
                    {t('chart_label_zoom_data_details')}
                </Box>
            </Box>
        );
    }

    return <Box sx={{ py: 1, px: 1.5 }}>{headerBlock}</Box>;
}
